import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, Table, notification, Modal, Select, Avatar, Typography } from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import { UserOutlined } from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import FilterReport from "./FilterReport";

const { Option } = Select;
const { Title } = Typography;

const createStyledTitle = (text) => (
  <span style={{ fontSize: '13px', color: '#7a0000', fontWeight: 700 }}>{text}</span>
);

const statusColor = (status) => {
  if (status === 'verified') return { background: '#52c41a', color: '#fff' };
  if (status === 'failed')   return { background: '#ff4d4f', color: '#fff' };
  return { background: '#faad14', color: '#fff' };
};

// Table columns definition
const columns = [
  {
    title: createStyledTitle("S.No"),
    dataIndex: "key",
    key: "key",
    fixed: 'left',
    width: 55,
    render: (text) => <span style={{ fontWeight: 600, fontSize: 12, color: '#7a0000' }}>{text}</span>,
  },
  {
    title: createStyledTitle("Name"),
    dataIndex: "name",
    key: "name",
    fixed: 'left',
    width: 220,
  },
  {
    title: createStyledTitle("Phone"),
    dataIndex: "phone_no",
    key: "phone_no",
    width: 130,
  },
  {
    title: createStyledTitle("Joining Date"),
    dataIndex: "joining_date",
    key: "joining_date",
    width: 120,
  },
  {
    title: createStyledTitle("Monthly Share"),
    dataIndex: "monthly_share",
    key: "monthly_share",
    width: 120,
  },
  // {
  //   title: createStyledTitle("Announced"),
  //   dataIndex: "total_announced_amount",
  //   key: "total_announced_amount",
  //   width: 110,
  // },
  {
    title: createStyledTitle("Received"),
    dataIndex: "total_received_amount",
    key: "total_received_amount",
    width: 110,
  },
  // {
  //   title: createStyledTitle("Due"),
  //   dataIndex: "total_due_amount",
  //   key: "total_due_amount",
  //   width: 100,
  // },
  {
    title: createStyledTitle("Last Pay Date"),
    dataIndex: "last_payment_date",
    key: "last_payment_date",
    width: 120,
  },
  {
    title: createStyledTitle("Last Status"),
    dataIndex: "last_payment_virify",
    key: "last_payment_virify",
    width: 110,
  },
  {
    title: createStyledTitle("Last Response"),
    key: "latest_payment_response",
    dataIndex: "latest_payment_response",
    width: 140,
  },
];

function ManualReport() {
  const [userList, setUserList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [staffList, setStaffList] = useState([]);
  const [filters, setFilters] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    createdBy: ''
  });

  useEffect(() => {
    getUserList();
  }, []);

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  async function getUserList(page = 1, limit = 30, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/users/manualReport?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setUserList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    getUserList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    getUserList(1, value, sortField, sortOrder, search, filters);
  };

  const debouncedGetUserList = useCallback(debounce((page, limit, sortField, sortOrder, search, filters) => {
    getUserList(page, limit, sortField, sortOrder, search, filters);
  }, 300), []);

  useEffect(() => {
    const filterKeys = Object.keys(filters);

    // Check if any filter other than 'createdBy' has a length of 3 or more
    const anyFilterHasMinLength = filterKeys.some(
      key => key !== 'createdBy' && filters[key].length >= 0
    );

    // Check if all filters are either empty or specifically 'createdBy'
    const allFiltersEmptyOrCreatedBy = filterKeys.every(
      key => key === 'createdBy' || !filters[key]
    );

    if (anyFilterHasMinLength || allFiltersEmptyOrCreatedBy) {
      debouncedGetUserList(currentPage, limit, sortField, sortOrder, search, filters);
    }
  }, [filters, currentPage, limit, sortField, sortOrder, search]);

  //For show image on model large
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const showModal = (image) => {
    setCurrentImage(image || userDummy);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleFiltersChange = (newFilters) => {
    setFilters(newFilters);
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Manual Report</span>}
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                // pagination={false}
                scroll={{ x: 'max-content' }}
                bordered
                title={() => (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Row gutter={[16, 16]}>
                      <FilterReport onFiltersChange={handleFiltersChange} />
                      <Col xs={24}>
                        <span style={{ marginRight: 10, fontSize: 13 }}>Records per page:</span>
                        <Select defaultValue={30} onChange={handleLimitChange}>
                          <Option value={20}>20</Option>
                          <Option value={30}>30</Option>
                          <Option value={60}>60</Option>
                          <Option value={80}>80</Option>
                          <Option value={100}>100</Option>
                        </Select>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={userList.map((user, index) => ({
                  key: (limit * (currentPage - 1)) + index + 1,
                  name: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Avatar
                        shape="square"
                        size={34}
                        src={user.profile_img || userDummy}
                        icon={!user.profile_img && <UserOutlined />}
                        onClick={() => showModal(user.profile_img || userDummy)}
                        style={{ cursor: 'pointer', borderRadius: 4, flexShrink: 0 }}
                      />
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 13, color: '#7a0000' }}>
                          <Link to={`/users/view/${user.mamber_id}`} style={{ color: '#1890ff' }}>{user.name}</Link>
                        </div>
                        {user.email_address && <div style={{ fontSize: 11, color: '#888' }}>{user.email_address}</div>}
                        {(user.relation_hn || user.father_name_en) && (
                          <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>
                            {user.relation_hn && <span style={{ color: '#aaa' }}>{user.relation_hn} </span>}
                            {user.father_name_en}{user.father_name_hn ? ' / ' + user.father_name_hn : ''}
                          </div>
                        )}
                      </div>
                    </div>
                  ),
                  phone_no: (
                    <div>
                      <div style={{ fontWeight: 500, fontSize: 13 }}>{user.phone_no || '—'}</div>
                      {user.alternate_phone_no && <div style={{ fontSize: 11, color: '#888' }}>{user.alternate_phone_no}</div>}
                    </div>
                  ),
                  monthly_share: <span style={{ fontWeight: 600, color: '#faad14' }}>{user.announced_amount ? 'Rs.' + user.announced_amount : '—'}</span>,
                  total_announced_amount: <span style={{ fontWeight: 500 }}>{user.total_announced_amount ? 'Rs.' + user.total_announced_amount : '—'}</span>,
                  total_received_amount: <span style={{ fontWeight: 600, color: '#52c41a' }}>{user.total_received_amount ? 'Rs.' + user.total_received_amount : '—'}</span>,
                  total_due_amount: <span style={{ fontWeight: 600, color: user.total_due_amount > 0 ? '#ff4d4f' : '#888' }}>{user.total_due_amount ? 'Rs.' + user.total_due_amount : '—'}</span>,
                  last_payment_date: <span style={{ fontSize: 12 }}>{user.last_payment_date ? moment(user.last_payment_date).format('DD MMM YYYY') : '—'}</span>,
                  last_payment_virify: user.last_payment_virify ? (
                    <span style={{ padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700, ...statusColor(user.last_payment_virify) }}>
                      {user.last_payment_virify.charAt(0).toUpperCase() + user.last_payment_virify.slice(1)}
                    </span>
                  ) : <span style={{ color: '#ccc' }}>—</span>,
                  latest_payment_response: <span style={{ fontSize: 12 }}>{user.latest_payment_response || '—'}</span>,
                  joining_date: <span style={{ fontSize: 12 }}>{user.joining_date ? moment(user.joining_date).format('DD MMM YYYY') : '—'}</span>,
                }))}
                
                pagination={{
                  ...pagination,
                  showTotal: total => `Total ${total} records`,
                  style: { marginRight: 20 }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
              />
            </div>
          </Card>
        </Col>
      </Row>

      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          src={currentImage}
          alt="Profile"
          style={{ width: '100%' }}
        />
      </Modal>
    </div>
  );
}

export default ManualReport;
